import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { OrdersSuccessPageRoutingModule } from "./orders-success-routing.module";
import { ComponentsModule } from "src/app/components/components.module";

import { OrdersSuccessPage } from "./orders-success.page";
//Pipes
import { ImageThanksPipe } from "src/app/pipes/images-thanks.pipe";
import { PipesModule } from "src/app/pipes/pipes.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    OrdersSuccessPageRoutingModule,
    ComponentsModule,
    PipesModule,
  ],
  declarations: [OrdersSuccessPage],
})
export class OrdersSuccessPageModule {}
